/**
 * Formation registration form toggle
 *
 * Hides Gravity Forms blocks on single formation pages
 * and adds a single toggle button to show/hide all of them.
 * Keeps forms visible when user is navigating a multi-page form.
 */
(function () {
  const formBlocks = document.querySelectorAll(
    '.content--formation .gravity-forms-block'
  );

  if (!formBlocks.length) {
    return;
  }

  // Check if a form is already in progress (past page 1 or has validation errors)
  const isFormInProgress = Array.from(formBlocks).some(function (block) {
    const pages = block.querySelectorAll('.gform_page');
    const isPastFirstPage =
      pages.length > 1 && pages[0].style.display === 'none';
    const hasValidationError = !!block.querySelector('.gform_validation_error');

    return isPastFirstPage || hasValidationError;
  });

  if (!isFormInProgress) {
    // Hide all forms by default only on fresh page load
    formBlocks.forEach(function (formBlock) {
      formBlock.classList.add('formation-registration--hidden');
    });
  }

  // Create a single toggle button before the first form
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'btn formation-registration__toggle';
  button.textContent = wp.i18n._x(
    'Register for the formation',
    'formation registration toggle',
    'vtx'
  );

  if (isFormInProgress) {
    button.classList.add('formation-registration__toggle--active');
  }

  formBlocks[0].parentNode.insertBefore(button, formBlocks[0]);

  // Toggle all forms on click
  button.addEventListener('click', function () {
    const isCurrentlyHidden = formBlocks[0].classList.contains(
      'formation-registration--hidden'
    );

    formBlocks.forEach(function (formBlock) {
      formBlock.classList.toggle(
        'formation-registration--hidden',
        !isCurrentlyHidden
      );
    });

    button.classList.toggle(
      'formation-registration__toggle--active',
      isCurrentlyHidden
    );
  });
})();
